/**
 * Constantes de validación reutilizables (documento por tipo, etc.).
 */

/** Códigos de tipo de documento (alineados con backend NeoTipoDocIdentidad.codigo) */
export const CODIGO_TIPO_DOC_CC = 'CC'; // Cédula de ciudadanía
export const CODIGO_TIPO_DOC_CE = 'CE'; // Cédula de extranjería
export const CODIGO_TIPO_DOC_PA = 'PA'; // Pasaporte
export const CODIGO_TIPO_DOC_PPT = 'PPT'; // Permiso por protección temporal (alfanumérico: mayúsculas y números)

/** Cédula de ciudadanía: solo dígitos, entre 6 y 10 caracteres */
export const DOC_CC_PATTERN = /^\d{6,10}$/;
export const DOC_CC_MESSAGE =
  'El número de cédula de ciudadanía debe tener entre 6 y 10 dígitos';

/** Cédula de extranjería / Pasaporte: mayúsculas, números, entre 5 y 15 caracteres */
export const DOC_CE_PATTERN = /^[A-Z0-9]{5,15}$/;
export const DOC_CE_MESSAGE =
  'El número debe tener entre 5 y 15 caracteres (letras mayúsculas y números)';

export const PASSWORD_SPECIAL_CHARS = '@$+#!%*?&-/_.,';
export const PASSWORD_COMPLEXITY_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$+#!%*?&/_.,-])[A-Za-z\d@$+#!%*?&/_.,-]{8,}$/;
export const PASSWORD_COMPLEXITY_HINT = `Debe tener mínimo 8 caracteres, 1 mayúscula, 1 minúscula, 1 número y 1 carácter especial (${PASSWORD_SPECIAL_CHARS}).`;